// The tab's favicon, in the page's accent color. A favicon is its own image and can't read
// the page's CSS, so each accent gets its own drawing in assets/favicons/<hex>.svg. The CSP
// only allows same-origin images, so the icon points at those files instead of a data URL.
// public/favicon.svg is the light theme's first accent, for when scripts don't run. A unit
// test keeps every file matching `faviconSvg()`.

const FAVICONS = import.meta.glob<string>("../assets/favicons/*.svg", {
  query: "?url",
  import: "default",
  eager: true,
});

/** The favicon drawing: a ring with tall eyes and a level mouth, in `color`. */
export function faviconSvg(color: string): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <circle cx="16" cy="16" r="13.6" fill="none" stroke="${color}" stroke-width="2.6" />
  <ellipse cx="11.8" cy="13.2" rx="1.8" ry="2.7" fill="${color}" />
  <ellipse cx="20.2" cy="13.2" rx="1.8" ry="2.7" fill="${color}" />
  <path d="M11 21 H21" stroke="${color}" stroke-width="2.4" stroke-linecap="round" />
</svg>
`;
}

/** The URL of the favicon in a `#rrggbb` accent, if the site has that drawing. */
export function faviconHref(color: string): string | undefined {
  return FAVICONS[`../assets/favicons/${color.slice(1)}.svg`];
}

/** Point the page's icon at the favicon in `color`. If the color hasn't changed, it writes
    nothing, so the browser doesn't redraw the tab. */
export function publishFavicon(doc: Document, color: string): void {
  const icon = doc.querySelector('link[rel="icon"]');
  if (!(icon instanceof HTMLLinkElement) || icon.dataset.accent === color) return;
  const href = faviconHref(color);
  if (!href) return;
  icon.dataset.accent = color;
  icon.href = href;
}
